export default "__VITE_ASSET__1fb34e79__"